var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmIcon04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(-859 -3182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(-329 1768)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(1188 1414)",
    fill: "#fd0000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(1198 1423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26848",
    "data-name": "Path 26848",
    d: "M-1.757-33.811H1.075v9.1H-1.757Zm1.416-4.52A1.639,1.639,0,0,1,1.3-36.693a1.641,1.641,0,0,1-1.64,1.641,1.641,1.641,0,0,1-1.641-1.641A1.639,1.639,0,0,1-.341-38.331",
    transform: "translate(1.982 38.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26849",
    "data-name": "Path 26849",
    d: "M2.849-33.811H5.561v1.245H5.6a2.975,2.975,0,0,1,2.678-1.47c2.863,0,3.391,1.883,3.391,4.333v4.989H8.841v-4.423c0-1.055-.021-2.412-1.47-2.412-1.471,0-1.7,1.149-1.7,2.335v4.5H2.849Z",
    transform: "translate(0.838 38.331)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmIcon04);
export default __webpack_public_path__ + "static/media/sm-icon-04.6e61aaab3409359c89c2bcced46a272c.svg";
export { ForwardRef as ReactComponent };